// File: noviopus-ats-client/src/features/Job/selectors.ts
import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './jobCreateSlice';

const selectDomain = (state: any) => state.jobCreate || initialState;

export const selectJobDraft = createSelector(
  [selectDomain],
  (state) => state.draft
);

export const selectUseOrganizationDefaults = createSelector(
  [selectJobDraft],
  (draft) => draft.useOrganizationDefaults
);

export const selectJobLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectJobSaveStatus = createSelector(
  [selectDomain],
  (state) => state.saveStatus
);

export const selectJobError = createSelector(
  [selectDomain],
  (state) => state.error
);

export const selectIsParsing = createSelector(
  [selectDomain],
  (state) => state.parsing
);

export const selectParsedData = createSelector(
    [selectDomain],
    (state) => state.parsedData
);

// --- NEW SELECTORS ---

export const selectShowOrgSelector = createSelector(
  [selectDomain],
  (state) => state.showOrgSelector
);

export const selectJobCompanyId = createSelector(
  [selectJobDraft],
  (draft) => draft.companyId
);